
import { combineReducers } from 'redux';
import { helpers } from './helpers/helpers.reducer'
import { management } from './management/management.reducer'

export const showcase = combineReducers({
    helpers,
    management
});
